import type { RouteObject } from 'react-router-dom'
import Blog from '@/pages/Blog'
import BlogPost from '@/pages/BlogPost'
import ComoFunciona from '@/pages/ComoFunciona'
import Contato from '@/pages/Contato'
import Home from '@/pages/Home'
import NotFound from '@/pages/NotFound'
import PoliticaGarantia from '@/pages/PoliticaGarantia'
import PoliticaPrivacidade from '@/pages/PoliticaPrivacidade'
import Servicos from '@/pages/Servicos'
import Sobre from '@/pages/Sobre'
import TermosUso from '@/pages/TermosUso'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/servicos', element: <Servicos /> },
  { path: '/como-funciona', element: <ComoFunciona /> },
  { path: '/blog', element: <Blog /> },
  { path: '/blog/:slug', element: <BlogPost /> },
  { path: '/sobre', element: <Sobre /> },
  { path: '/contato', element: <Contato /> },
  { path: '/politica-de-privacidade', element: <PoliticaPrivacidade /> },
  { path: '/termos-de-uso', element: <TermosUso /> },
  { path: '/politica-de-garantia', element: <PoliticaGarantia /> },
  { path: '*', element: <NotFound /> },
]

function App() {
  return useRoutes(routes)
}

export default App
